export default __webpack_public_path__ + "static/concept-live-6c2065ebe135744690f014b634c9e9b6.jpg";